// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d0b9f406","455":"387c453f","977":"80a2ef39"}[chunkId] + ".chunk.js";
};